import { connect } from "react-redux";
import PurchaseOrders from "./PurchaseOrders";
import {
  purchaseOrders,
  purchaseOrdersLoading,
  purchaseOrderLoading,
  purchaseOrdersPagination,
  getError,
} from "../../store/selectors/purchaseOrders.selector";

const mapStateToProps = (state) => {
  const allPurchaseOrders = purchaseOrders(state);
  const pageLoading = purchaseOrdersLoading(state);
  const loading = purchaseOrderLoading(state);
  const pagination = purchaseOrdersPagination(state);
  const error = getError(state);
  return { error, allPurchaseOrders, pagination, loading, pageLoading };
};

export default connect(mapStateToProps, null)(PurchaseOrders);
